import React from 'react'
import PropTypes from 'prop-types'
import { ToggleButton, Label1 } from '@sainsburys-tech/fable'
import { Store, DeliveryOneMan, CheckCircleFilled, CrossCircleFilled } from '@sainsburys-tech/icons'

import { FULFILMENT_TYPES } from '../fulfilmentBoxUtils'

const fulfilmentHeadings = {
  collection: {
    label: 'Collection',
    icon: <Store />
  },
  delivery: {
    label: 'Delivery',
    icon: <DeliveryOneMan />
  }
}

const ICON_GREEN = 'ds-text-green'
const ICON_RED = 'ds-text-red'

const availabilityIcons = {
  tick: <CheckCircleFilled className={ICON_GREEN} />,
  clock: <CheckCircleFilled className={ICON_GREEN} />,
  calendar: <CheckCircleFilled className={ICON_GREEN} />,
  out_of_stock: <CrossCircleFilled className={ICON_RED} />
}

const FulfilmentOptionButton = ({ type, value, message, availabilityIcon, isDisabled, isActive, ...props }) => {
  const { label, icon } = fulfilmentHeadings[type] || {}

  return (
    <ToggleButton
      data-testid={`fulfilment-option-${type}`}
      value={value}
      variant='secondary'
      colourScheme={{ brand: 'argos', colour: 'fulfilment-option' }}
      isActive={isActive}
      isDisabled={isDisabled}
      className={`fulfilment-option ${isActive ? 'fulfilment-option--active' : 'ds-border-black ds-shadow-none'}`}
      {...props}
    >
      <div className='ds-flex'>
        <span className='ds-c-button__icon ds-mr-2 ds-mb-1'>{icon}</span>
        <span>{label}</span>
      </div>
      <Label1 data-testid='message' className='ds-font-normal' icon={{ icon: availabilityIcons[availabilityIcon] }}>
        {message}
      </Label1>
    </ToggleButton>
  )
}

FulfilmentOptionButton.propTypes = {
  type: PropTypes.oneOf([FULFILMENT_TYPES.COLLECTION, FULFILMENT_TYPES.DELIVERY]).isRequired,
  value: PropTypes.oneOf([FULFILMENT_TYPES.COLLECTION, FULFILMENT_TYPES.DELIVERY]).isRequired,
  message: PropTypes.string,
  availabilityIcon: PropTypes.oneOf(['tick', 'out_of_stock', 'clock', 'calendar']).isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired
}

export default FulfilmentOptionButton
